import React from 'react';
import Carousel from '../Carousel/Carousel';

const Main = () => {
  return (
    <div>
        <Carousel/>
    </div>
  )
}

export default Main;